import { render, staticRenderFns } from "./Preescolar.vue?vue&type=template&id=523d8bee&scoped=true"
import script from "./Preescolar.vue?vue&type=script&lang=js"
export * from "./Preescolar.vue?vue&type=script&lang=js"
import style0 from "./Preescolar.vue?vue&type=style&index=0&id=523d8bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523d8bee",
  null
  
)

export default component.exports